/** @jsx h */
import { showCount } from '../config';
import Pagination from './Pagination';
import ResultTitle from './ResultTitle';

const TeaserArticle = ({
  allResultCount,
  list,
  pagination,
  loadMore,
  pluginNamespace,
}) => {
  function handleLoadMoreClick() {
    loadMore();
  }
  return (
    <div className="search-section__result-container">
      {allResultCount && showCount && (
        <div className="search-section__result-header">
          <ResultTitle allResultCount={allResultCount} />
        </div>
      )}

      <div className="news-teaser news-teaser--raw">
        <div className="news-teaser__inner">
          <ul className="news-teaser__list">
            {list.map(result => (
              <li className="news-teaser__item" key={result.uid}>
                <a
                  href={result.url}
                  className="btn"
                  {...(result.isExternal
                    ? { target: '_blank', rel: 'noopener' }
                    : '')}
                >
                  {result.image && (
                    <picture className="news-teaser__image" loading="lazy">
                      <img
                        alt={result.image.alt ? result.image.alt : ''}
                        src={result.image.src}
                      />
                    </picture>
                  )}
                </a>
                {result.mark && (
                  <span className="news-teaser__label is-small">
                    {result.mark}
                  </span>
                )}
                <h3 className="is-link">
                  <a
                    href={result.url}
                    className="btn"
                    {...(result.isExternal
                      ? { target: '_blank', rel: 'noopener' }
                      : '')}
                  >
                    <span>{result.title}</span>
                  </a>
                </h3>
                <p>{result.teaser}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Pagination
        pagination={pagination}
        triggerLoadMore={handleLoadMoreClick}
        pluginNamespace={pluginNamespace}
      />
    </div>
  );
};

export default TeaserArticle;
